import {format, startOfMonth} from "date-fns";


export const StartsEndsCurrentMonth = () => {
    const currentDate = format(new Date(), 'yyyy-MM-dd');
    const startDate = format(startOfMonth(currentDate), 'yyyy-MM-dd');
    return [startDate, currentDate];
}